import i18next from 'i18next'

import { ValidateFormService } from 'services/ValidateFormService'
import { OrderLocationViewModel } from 'sections/LKSection/modules/OrderModule/stores/models/OrderLocationViewModel'
import {
  COURIER_WAY_MAX,
  PICKPOINT_DESCRIPTION_MAX,
  PICKPOINT_DESCRIPTION_MIN,
} from 'sections/LKSection/shared/PickPointSharedModule/data'
import { PickPointType } from 'sections/LKSection/shared/PickPointSharedModule/types'
import { Country } from 'shared/types/types'

import { OrderKeys } from '../../../data'
import { PickPointLocation } from '../../../types'

export class ValidateOrderLocation extends ValidateFormService {
  validate = (
    locationModel: OrderLocationViewModel,
    returnType: 'boolean' | 'array' = 'boolean',
    country: Country,
    isMoving: boolean = false,
  ) => {
    const errors: string[] = []
    const isCIS = country !== Country.RU

    const getKey = (key: string) => `${OrderKeys.locationStep}.validate.${key}`

    if (!isCIS && locationModel.pickPointType === null) {
      errors.push(i18next.t(getKey('Необходимо выбрать тип ПВЗ')))
    }

    if (locationModel.cityItem === null) {
      errors.push(i18next.t(getKey('Необходимо выбрать город')))
    }
    if (locationModel.streetItem === null || !locationModel.houseWasSelected) {
      errors.push(i18next.t(getKey('Необходимо выбрать улицу')))
    }

    if (
      ((locationModel.pickPointType === PickPointType.partner && !isCIS) || country === Country.GE) &&
      locationModel.subsidyInfo.length > 0 &&
      locationModel.subsidyHexTypeItem === null &&
      !isMoving
    ) {
      errors.push(i18next.t(getKey('Необходимо выбрать тип субсидии')))
    }

    if (locationModel.description.trim().length === 0) {
      errors.push(i18next.t(getKey('Поле Как найти ПВЗ')))
    } else {
      if (locationModel.description.trim().length < 30) {
        errors.push(i18next.t(getKey('descriptionMinLength'), { count: PICKPOINT_DESCRIPTION_MIN }))
      }
      if (locationModel.description.length > 200) {
        errors.push(i18next.t(getKey('descriptionMaxLength'), { count: PICKPOINT_DESCRIPTION_MAX }))
      }
    }

    if (locationModel.floorLevel === PickPointLocation.shoppingMall && locationModel.courierWay.trim().length === 0) {
      errors.push(i18next.t(getKey('Поле Информация для курьеров')))
    }

    if (locationModel.courierWay.length > 256) {
      errors.push(i18next.t(getKey('courierWayMaxLength'), { count: COURIER_WAY_MAX }))
    }

    return returnType === 'boolean' ? this.hasNotErrors(errors) : errors
  }
}

export const validateOrderLocation = new ValidateOrderLocation()
